import { ReactComponent as BkgComponent } from '../assets/bkg-cap.svg';
import SvgRouteNavigator from '../components/SvgRouteNavigator';

const linkRoutes: Record<string, string> = {
  "link-cycle-1": "/cap/cycle/1",
  "link-cycle-2": "/cap/cycle/2",
  "link-cycle-3": "/cap/cycle/3",
  "link-misc": "/cap/misc",
  "link-back": "/main",
};

function Cap() {
  return <SvgRouteNavigator SvgComponent={BkgComponent} linkRoutes={linkRoutes} />;
}

export default Cap;
